import React, { PureComponent } from 'react'
import { sleep } from 'util/functions'
import { MatrixEvent } from 'matrix-js-sdk'
import { getMatrixClient } from 'ducks/chat/utils/client'

export default class ShadowBody extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      isTimeout: false,
    }
  }

  componentDidMount() {
    this.findShadowEvent()
  }

  componentWillUnmount() {
    this.isUnmounting = true
  }

  async findShadowEvent(attempt = 0) {
    const { accountChatRoomId, mxEvent, onMessageAllowed } = this.props
    const { event_id: eventId } = mxEvent.getContent()
    if (attempt > 10) {
      if (!this.isUnmounting) {
        this.setState({
          isTimeout: true,
        })
      }
      return
    }
    if (!eventId) return
    const client = getMatrixClient()
    const room = client.getRoom(accountChatRoomId)
    const shadowMxEvent = await room.findEventById(eventId)
    if (shadowMxEvent) {
      mxEvent.makeReplaced(shadowMxEvent)
      // Bad nameing and design by matrix. The makeReplaced causes
      // the matrix event to get mutated. After that change we call onMessageAllowed
      // which calls forceUpdate() which then renders the change
      onMessageAllowed()
      // No need to update the loading state as the onMessageAllowed
      // will cause a re-render upstream and the event will be rendered
      // with the correct type instead of the shadow handler
    } else {
      await this.loadShadowEvent(room, eventId)
      this.findShadowEvent(attempt + 1)
    }
  }

  async loadShadowEvent(room, eventId) {
    try {
      const client = getMatrixClient()
      const event = await client.fetchRoomEvent(room.roomId, eventId)
      if (event) {
        const matrixEvent = new MatrixEvent(event)
        room.addLiveEvents([matrixEvent], 'ignore')
        return matrixEvent
      }
    } catch {
      // Supress errors
    }
    await sleep(100)
    return null
  }

  render() {
    const { isLoading } = this.state
    if (isLoading) {
      return (
        <span className="mx_MTextBody mx_EventTile_content">
          <div className="mx_EventTile_box loading">
            <span>•</span>
            <span>•</span>
            <span>•</span>
          </div>
        </span>
      )
    }
    return null
  }
}
